export const typeIds = [
  {
    value: "CC",
    label: "Cédula de ciudadanía",
  },
  {
    value: "TI",
    label: "Tarjeta de identidad",
  },
  {
    value: "RC",
    label: "Registro civil",
  },
  {
    value: "CE",
    label: "Cédula de extranjería",
  },
  {
    value: "PP",
    label: "Pasaporte",
  },
];
